var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 17,
    viewBox: "0 0 215 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M2 15L10.3347 8.5C15.2343 4.67897 22.1046 4.67897 27.0042 8.5V8.5C31.9037 12.321 38.774 12.321 43.6736 8.5V8.5C48.5732 4.67897 55.4435 4.67897 60.343 8.5V8.5C65.2426 12.321 72.1129 12.321 77.0125 8.5V8.5C81.912 4.67897 88.7823 4.67897 93.6819 8.5V8.5C98.5815 12.321 105.452 12.321 110.351 8.5V8.5C115.251 4.67897 122.121 4.67897 127.021 8.5L127.368 8.77087C132.142 12.494 138.759 12.7588 143.815 9.42892L147.735 6.84756C152.026 4.0213 157.71 4.58271 161.366 8.19398V8.19398C165.294 12.0741 171.495 12.3839 175.885 9.03492C180.625 5.41843 185.36 2 186.241 2C186.553 2 187.244 2.42682 188.18 3.13837C195.819 8.94634 206.537 9.09322 213 2V2",
    stroke: "#FFB300",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.aae929b42409f89481eddc8ba4dbc1ac.svg";
export { ForwardRef as ReactComponent };